import React, { useState, useEffect } from 'react';
import {
    Layout,
    Select,
    Input,
    Button,
    Table,
    Modal,
    message,
    Form,
    Row,
    Col,
    InputNumber, DatePicker, AutoComplete, Card, Popconfirm,
} from 'antd';
import axios from 'axios';
import {
    copyToClipboard,
    estimateAmountByPrice,
    estimatePriceByAmount,
    fetchTokenOptions,
    formattedAddress, getScanUrl
} from "../../util";
import dayjs from "dayjs";

const { Content } = Layout;
const { Option } = Select;

const { RangePicker } = DatePicker;
const ProjectGroupManagement = () => {
    const [walletGroups, setWalletGroups] = useState([]);
    const [projectData, setProjectData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [projectList, setProjectList] = useState([]);  // 用于存储项目列表
    const [selectedAccountProject, setSelectedAccountProject] = useState(null);
    const [selectedCreateTradeProject, setSelectedCreateTradeProject] = useState(null);
    const [selectedTradeInfoProject, setSelectedTradeInfoProject] = useState(null);
    const [chains, setChains] = useState([]);  // 新增：存储链的列表
    const [selectedChain, setSelectedChain] = useState(null);  // 新增：选中的链
    const [addWalletModalVisible, setAddWalletModalVisible] = useState(false);
    const [selectedWalletGroup, setSelectedWalletGroup] = useState(null);
    const [form] = Form.useForm();
    const [selectedProjectDetails, setSelectedProjectDetails] = useState(null);
    const [selectedGroup, setSelectedGroup] = useState(null); // selected wallet group
    const [tradingGroups, setTradingGroups] = useState([]); // data for trading groups
    const [depuedTradingGroups, setDepuedTradingGroups] = useState([]);
    const [totalItems, setTotalItems] = useState(0); // total items for pagination
    const [searchParams, setSearchParams] = useState({}); // search params for API
    const [transactionModalVisible, setTransactionModalVisible] = useState(false);
    const [transactionDetails, setTransactionDetails] = useState([]);
    const [tokenOptions, setTokenOptions] = useState({});
    const [deleteModalVisible, setDeleteModalVisible] = useState(false);
    const [selectedStopGroupId, setSelectedStopGroupId] = useState(null);
    const [tokenAddress, setTokenAddress] = useState('');
    const [quoteAddress, setQuoteAddress] = useState('');
    const [pairTokenOptions, setPairTokenOptions] = useState([]);
    const [detailPage, setDetailPage] = useState(1);
    const pageSize = 10;

    const [price, setPrice] = useState(null);
    const [amount, setAmount] = useState(null);

    const [taskType, setTaskType] = useState('prepare');

    const [taskDetail, setTaskDetail] = useState(null);
    const [taskDetailType, setTaskDetailType] = useState(null);
    const [limitTransactions, setLimitTransactions] = useState([]);
    const [taskDetailModalVisible, setTaskDetailModalVisible] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalTasks, setTotalTasks] = useState(0);

// 用于加载中状态
    const [loadingTasks, setLoadingTasks] = useState(false);

    const [limitTasks, setLimitTasks] = useState([]);
    const [limitTotal, setLimitTotal] = useState(0);
    const [limitPage, setLimitPage] = useState(1);
    const [disperseModalVisible, setDisperseModalVisible] = useState(false);
    const [currentTaskId, setCurrentTaskId] = useState(null);
    const [disperseFilters, setDisperseFilters] = useState({
        source_wallet_address: '',
        target_wallet_address: '',
        status: '',
        transfer_sequence: ''
    });
    const [disperseData, setDisperseData] = useState([]);
    const [dispersePage, setDispersePage] = useState(1);
    const [dispersePageSize] = useState(20);
    const [disperseTotal, setDisperseTotal] = useState(0);
    const [disperseLoading, setDisperseLoading] = useState(false);

    const openDisperseModal = (taskId) => {
        console.log(taskId);
        setCurrentTaskId(taskId);
        setDisperseModalVisible(true);
        setDispersePage(1);
        setDisperseFilters({ source_wallet_address: '', target_wallet_address: '', status: '', transfer_sequence: '' });
        fetchDisperseTransactions(taskId, 1); // 初始加载
    };

    const fetchDisperseTransactions = async (_taskId, _page) => {
        const taskId = typeof _taskId === 'number' ? _taskId : currentTaskId;
        const page = typeof _page === 'number' ? _page : dispersePage;

        try {
            setDisperseLoading(true);
            const token = localStorage.getItem('token');
            const params = {
                task_id: taskId,
                page,
                size: dispersePageSize,
                ...disperseFilters,
            };
            const res = await axios.get('/api/v1/disperse_trading/transactions', {
                params,
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (res.data.code === 0) {
                setDisperseData(res.data.data.items || []);
                setDisperseTotal(res.data.data.total || 0);
            } else {
                message.error(res.data.msg || '获取打散交易事务失败');
            }
        } catch (err) {
            message.error('请求失败');
        } finally {
            setDisperseLoading(false);
        }
    };



    const fetchLimitTasks = async (page = 1) => {
        const token = localStorage.getItem('token');
        try {
            const res = await axios.get(`/api/v1/limit_order_trading/list?page=${page}&size=10`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (res.data.code === 0) {
                setLimitTasks(res.data.data.items);
                setLimitTotal(res.data.data.total);
            } else {
                message.error(res.data.msg || '加载失败');
            }
        } catch (err) {
            message.error('请求失败');
        }
    };

    useEffect(() => {
        if (taskType === 'limit') {
            fetchLimitTasks(limitPage);
        }
    }, [taskType, limitPage]);


    const [prepareParams, setPrepareParams] = useState({
        chain_id: 56,
        group_id: null,
        token_addresses: [],
        fund_percentage: '',
        wait_seconds: '',
        trading_rounds: '',
        duration_seconds: 0
    });
    const [neutralParams, setNeutralParams] = useState({
        chain_id: 56,
        group_ids: [],
        pair_address: '',
        quote_address: '',
        max_quote_per_swap: '',
        total_quote: '',
        duration_seconds: 0,
        swap_mode: 'base_neutral'
    });
    const [limitParams, setLimitParams] = useState({
        group_id: null,
        chain_id: null,
        pool_address: '',
        token_address: '',
        pair_token_address: '',
        min_price: '',
        max_price: '',
        buy_amount_min: '',
        buy_amount_max: '',
        sell_amount_min: '',
        sell_amount_max: '',
        slippage: '',
        expired_time: '',
    });

    const [disperseParams, setDisperseParams] = useState({
        chain_id: null,
        source_group_id: null,
        target_group_id: null,
        token_address: '',
        pair_address: '',
        quote_address: '',
        target_amount: '',
        duration_seconds: 0,
        average_transfer_amount: '',
    });

    const [taskList, setTaskList] = useState([]);


    useEffect(() => {
        if (selectedCreateTradeProject) {
            const selectedProject = projectList.find(p => p.project_name === selectedCreateTradeProject);
            if (selectedProject) {

                const chain = chains.find(c => c.chain_id === selectedProject.chain_id);
                const tokens = tokenOptions[chain?.chain_name] || [];
                const uniqueOptions = Array.from(new Map(
                    tokens.map(token => [token.address, {
                        value: token.address,
                        label: `${token.name} - ${token.address}`,
                    }])
                ).values());
                setPairTokenOptions(uniqueOptions);
            } else {
                setPairTokenOptions([]);
            }
        } else {
            setPairTokenOptions([]);
        }
    }, [selectedCreateTradeProject, projectList, tokenOptions]);

    useEffect(() => {
        const loadTokenOptions = async () => {
            const data = await fetchTokenOptions();
            setTokenOptions(data);
        };

        loadTokenOptions();
    }, []);

    useEffect(() => {
        fetchWalletGroups();
        fetchChains(); // 获取链的列表
        fetchProjects();
        fetchTradingGroups();
    }, []);

    useEffect(() => {
        fetchProjectAccounts();
    }, [selectedAccountProject])

    useEffect(() => {
        console.log('qiehuan');
        // setTaskList([]);
        fetchTasks();
    }, [taskType, currentPage]);

    // useEffect(() => {
    //     fetchTradingGroups();
    // }, [selectedTradeInfoProject, ])

    const handleTaskTypeChange = (value) => {
        console.log('handleTaskTypeChange', value);
        setTaskType(value);
        setTaskList([]);
        // fetchTasks();
    }

    const handleCreateTask = async () => {
        try {
            const token = localStorage.getItem('token');
            let response;

            if (taskType === 'prepare') {
                prepareParams.token_addresses = tokenAddress;
                response = await axios.post('/api/v1/batch_token_trading/create', prepareParams, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
            } else if (taskType === 'neutral') {
                neutralParams.quote_address = quoteAddress;
                response = await axios.post('/api/v1/neutral_token_trading/create', neutralParams, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
            } else if (taskType === 'limit') {
                response = await axios.post('/api/v1/limit_order_trading/create', limitParams, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
            } else if (taskType === 'disperse') {
                disperseParams.duration_seconds = parseInt(disperseParams.duration_seconds);
                response = await axios.post('/api/v1/disperse_trading/create', disperseParams, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
            }

            if (response.data.code === 0) {
                message.success('任务创建成功');
                fetchTasks(); // 刷新任务列表
            } else {
                message.error(response.data.msg || '任务创建失败');
            }
        } catch (err) {
            console.error(err);
            message.error('任务创建失败');
        }
    };


// 处理代币地址变化
    const handleTokenAddressChange = (value) => {
        setTokenAddress(value);
    };

    const fetchTasks = async () => {
        setLoadingTasks(true);
        const token = localStorage.getItem('token');

        const urlMap = {
            prepare: '/api/v1/batch_token_trading/list',
            neutral: '/api/v1/neutral_token_trading/list',
            limit: '/api/v1/limit_order_trading/list',
            disperse: '/api/v1/disperse_trading/list'
        };

        try {
            const url = `${urlMap[taskType]}?page=${currentPage}&size=10`;
            const res = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (res.data.code === 0) {
                setTaskList(res.data.data.items);
                setTotalTasks(res.data.data.total);
            } else {
                message.error(res.data.msg || '加载任务失败');
            }
        } finally {
            setLoadingTasks(false);
        }
    };

    const handleViewDetail = async (taskIdOrRecord) => {
        const requestedTaskType = taskType;
        const taskId = typeof taskIdOrRecord === 'object'
            ? (taskIdOrRecord?.task_id ?? taskIdOrRecord?.id)
            : taskIdOrRecord;

        if (taskId === null || taskId === undefined) {
            message.error('任务ID不存在，无法加载详情');
            return;
        }

        const token = localStorage.getItem('token');
        const urlMap = {
            prepare: '/api/v1/batch_token_trading/info',
            neutral: '/api/v1/neutral_token_trading/info',
            limit: '/api/v1/limit_order_trading/info',
            disperse: '/api/v1/disperse_trading/detail'
        };

        try {
            const res = await axios.get(urlMap[requestedTaskType], {
                params: { task_id: taskId },
                headers: { Authorization: `Bearer ${token}` }
            });
            if (res.data.code === 0) {
                const detail = requestedTaskType === 'disperse'
                    ? (res.data.data?.task || {})
                    : res.data.data;

                if (!detail) {
                    message.error('接口未返回任务详情');
                    return;
                }

                setTaskDetail(detail);
                setTaskDetailType(requestedTaskType);
                setLimitTransactions(
                    requestedTaskType === 'limit' && Array.isArray(detail.transactions)
                        ? detail.transactions
                        : []
                );
                setDetailPage(1);
                setTaskDetailModalVisible(true);
            } else {
                message.error(res.data.msg || '加载详情失败');
            }
        } catch (err) {
            console.error(err);
            message.error('请求失败');
        }
    };


    const fetchChains = async () => {
        try {
            const response = await axios.get('/api/v1/chain/list');
            if (response.data.code === 0) {
                setChains(Object.values(response.data.data));  // 提取链的列表
            } else {
                message.error(response.data.data);
            }
        } catch (error) {
            message.error(error);
        }
    };

    const handleStopTradingGroup = async () => {
        if (!selectedStopGroupId) {
            message.warning('请选择交易组 ID');
            return;
        }

        try {
            const token = localStorage.getItem('token');
            const response = await axios.post(
                '/api/v1/trading/group/stop',
                { task_id: parseInt(selectedStopGroupId) },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data.code === 0) {
                message.success('交易组已停止');
                fetchTradingGroups(); // 刷新交易组列表
                setSelectedStopGroupId(null);
            } else {
                message.error(response.data.msg || '停止失败');
            }
        } catch (error) {
            console.error('停止交易组失败:', error);
            message.error('网络错误，无法停止交易组');
        }
    };


    // 获取钱包组列表
    const fetchWalletGroups = async (name = '') => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get('/api/v1/wallet/list', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params: { name, page: 1, size: 999 },
            });
            if (response.data.code === 0) {
                setWalletGroups(response.data.data.items);
            } else {
                message.error(response.data.data);
            }
        } catch (error) {
            message.error(error);
        }
    };

    // 查询项目组账户信息
    const fetchProjects = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`/api/v1/projects/list`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            if (response.data.code === 0) {
                setProjectList(response.data.data.item);
            } else {
                message.error(response.data.data);
            }
        } catch (error) {
            message.error(error);
        } finally {
            setLoading(false);
        }
    };

    const fetchProjectAccounts = async () => {
        if (!selectedAccountProject) {
            message.warning('请选择项目');
            return;
        }
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get('/api/v1/projects/accounts', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params: { project_name: selectedAccountProject },
            });

            if (response.data.code === 0) {
                setProjectData(response.data.data.items);
            } else {
                message.error(response.data.data);
            }
        } catch (error) {
            message.error(error);
        } finally {
            setLoading(false);
        }
    };


    // 添加钱包组到项目组
    const handleAddWalletToProject = async () => {
        if (!selectedWalletGroup || !selectedAccountProject) {
            message.warning('请选择钱包组和项目');
            return;
        }

        try {
            const token = localStorage.getItem('token');
            const response = await axios.post('/api/v1/projects/wallet/add', {
                group_id: selectedWalletGroup,
                project_name: selectedAccountProject,
            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.data.code === 0) {
                message.success('钱包组添加成功');
                setAddWalletModalVisible(false);
                fetchProjectAccounts();
            } else {
                message.error(response.data.data);
            }
        } catch (error) {
            message.error(error);
        }
    };

    // 打开删除钱包组弹窗
    const openDeleteModal = () => {
        if (!selectedAccountProject) {
            return message.warning('请先选择一个项目');
        }
        setDeleteModalVisible(true);
    };

    // 确认删除
    const handleDeleteWalletGroup = async () => {
        if (!selectedGroup) {
            return message.warning('请选择要删除的钱包组');
        }
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            await axios.post('/api/v1/projects/wallet/remove', {
                    group_id: selectedGroup,
                    project_name: selectedAccountProject,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                });
            message.success('删除成功');
            setDeleteModalVisible(false);
            fetchProjectAccounts(); // 刷新数据
        } catch (error) {
            console.error(error);
            message.error('删除失败');
        } finally {
            setLoading(false);
        }
    };


    // 更新项目组内钱包余额
    const handleUpdateBalances = async () => {
        const groupId = 1; // Replace with actual selected wallet group id
        const projectName = selectedAccountProject;

        try {
            const response = await axios.post('/api/v1/projects/wallet/refresh', {
                group_id: groupId,
                project_name: projectName,
            });

            if (response.data.code === 0) {
                const { estimate_finish_second } = response.data.data;
                if (estimate_finish_second === 0) {
                    message.success('项目组余额已成功刷新');
                } else {
                    message.success(`余额刷新中，预计完成时间：${estimate_finish_second}秒`);
                }
            } else {
                message.error('更新钱包余额失败');
            }
        } catch {
            message.error('网络错误，无法更新钱包余额');
        }
    };

    // 创建交易组
    const createTradingGroup = async (values) => {
        setLoading(true);
        const token = localStorage.getItem('token');
        let fee = 0;
        if (values.fee) {
            fee = parseInt(values.fee)
        }

        const payload = {
            project_name: values.project_name,  // 使用项目名称
            group_id: values.group_id,
            total_amount: parseFloat(values.total_amount),  // 代币总数量
            price_limit: values.price_limit.toString(),
            duration_minutes: values.duration_minutes,
            pair_token_address: values.pair_token_address,
            direction: values.direction,
            transaction_count: values.transaction_count, // 总交易次数
            fee: fee
        };

        try {
            const response = await axios.post('/api/v1/trading/group/create', payload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.data.code === 0) {
                message.success('交易组创建成功');
                fetchTradingGroups();
            } else {
                handleTradingGroupError(response.data.code, response.data.data);
            }
        } catch (error) {
            message.error(error);
        } finally {
            setLoading(false);
        }
    };

    // 处理创建交易组错误码
    const handleTradingGroupError = (code, msg) => {
        switch (code) {
            case 4005:
                message.error('无效的交易对');
                break;
            case 4006:
                message.error('价格限制无效');
                break;
            default:
                message.error(msg);
                break;
        }
    };

    // 查询交易组列表
    const fetchTradingGroups = async (values = {}) => {
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                throw new Error('Token is missing');
            }

            const { time_range, page = 1, size = 20, project_name, trading_group_id, group_id } = values;

            let start_time_epoch = null;
            let end_time_epoch = null;

            // 获取时间范围并转换为时间戳
            if (time_range && time_range.length === 2) {
                start_time_epoch = new Date(time_range[0]).setHours(0, 0, 0, 0) / 1000;
                end_time_epoch = new Date(time_range[1]).setHours(23, 59, 59, 0) / 1000;
            }

            const response = await axios.get('/api/v1/trading/group/list', {
                params: {
                    project_name,
                    trading_group_id,
                    group_id,
                    start_time: start_time_epoch,
                    end_time: end_time_epoch,
                    page,
                    size,
                },
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.data.code === 0) {
                setTradingGroups(response.data.data.items); // 设置数据
                setTotalItems(response.data.data.total); // 设置总记录数
            } else {
                message.error(response.data.msg);
            }
        } catch (error) {
            console.error('Error fetching trading groups:', error);
            message.error('网络错误，无法加载交易组列表');
        } finally {
            setLoading(false);
        }
    };


    // 查询交易详情
    // Function to fetch transaction details
    const fetchTransactionDetails = async (tradingGroupId) => {
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`/api/v1/trading/group/info`, {
                params: { task_id: tradingGroupId },
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.data.code === 0) {
                const transactionDetails = response.data.data.items.map(item => ({
                    ...item,
                    direction: response.data.data.direction, // 将 direction 添加到每个交易项中
                }));
                console.log(transactionDetails); // For debugging: log the transaction details

                // Set state to store the transaction details and show the modal
                setTransactionDetails(transactionDetails);
                setTransactionModalVisible(true);
            } else {
                message.error(response.data.data);
            }
        } catch (error) {
            message.error(error);
        } finally {
            setLoading(false);
        }
    };

    // 去重函数，根据 group_id 去重
    const uniqueProjectData = (projectData) => {
        return projectData.reduce((acc, current) => {
            const exists = acc.find(item => item.group_id === current.group_id);
            if (!exists) {
                acc.push(current);
            }
            return acc;
        }, []);
    }

    // 表格列定义
    const projectColumns = [
        { title: '序号', render: (_, __, index) => index + 1 },
        {
            title: '钱包组名', dataIndex: 'group_name',
            sorter: (a, b) => a.group_name.localeCompare(b.group_name), // 字符串排序
        },
        {
            title: '地址',
            dataIndex: 'address',
            render: (text, record) => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    {/* 地址链接 */}
                    <a href={record.scan_url || `https://basescan.org/address/${text}`}
                       target="_blank"
                       rel="noopener noreferrer">
                        {formattedAddress(text)}
                    </a>

                    {/* 复制按钮 */}
                    <Button
                        size="small"
                        onClick={() => copyToClipboard(text)}>
                        复制
                    </Button>
                </div>
            ),
        },
        { title: '链类型', dataIndex: 'chain_type' },
        {
            title: '代币余额',
            dataIndex: 'token_balance',
            sorter: (a, b) => Number(a.token_balance) - Number(b.token_balance), // 数字排序
        },
        {
            title: 'Gas 币余额',
            dataIndex: 'gas_balance',
            sorter: (a, b) => Number(a.gas_balance) - Number(b.gas_balance),
        },
        {
            title: 'USDC 余额',
            dataIndex: 'usdc_balance',
            sorter: (a, b) => Number(a.usdc_balance) - Number(b.usdc_balance),
        },
        {
            title: 'USDT 余额',
            dataIndex: 'usdt_balance',
            sorter: (a, b) => Number(a.usdt_balance) - Number(b.usdt_balance),
        },
    ];

    const tradingGroupColumns = [
        {
            title: '序号',
            dataIndex: 'index',
            render: (_, __, index) => index + 1,
            width: 60,  // 设置宽度
        },
        {
            title: '任务ID',
            dataIndex: 'task_id',  // "task_id" corresponds to the trading group ID
            width: 100,  // 设置宽度
        },
        {
            title: '项目名',
            dataIndex: 'project_name',  // "project_name" from the response
            width: 150,  // 设置宽度
        },
        {
            title: '开始时间',
            dataIndex: 'start_time',
            render: (timestamp) => new Date(timestamp * 1000).toLocaleString(),  // Convert UNIX timestamp to human-readable date
            width: 120,  // 设置宽度
        },
        {
            title: '预计结束时间',
            dataIndex: 'estimated_end_time',
            render: (timestamp) => new Date(timestamp * 1000).toLocaleString(),  // Convert UNIX timestamp to human-readable date
            width: 120,  // 设置宽度
        },
        {
            title: '操作标的 Trading Pair',
            // render: (text, record) => `${formattedAddress(record.pair_token_address)}`,  // Display project token and pair token addresses
            render: (text, record) => (

                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    {formattedAddress(record.pair_token_address)}
                    <Button
                        size="small"
                        onClick={() => copyToClipboard(record.pair_token_address)}>
                        复制
                    </Button>
                </div>
            ),
            width: 60,  // 设置宽度
        },
        {
            title: '总金额',
            dataIndex: 'total_amount',  // "total_amount" from the response
            width: 120,  // 设置宽度
            render: (text) => {
                // 使用Number来处理大数字，并保留四位有效数字
                const formattedAmount = Number(text).toExponential(2);
                return `${formattedAmount}`;
            },
        },
        {
            title: '完成钱包数',
            render: (text, record) => `${record.completed_account_count}/${record.total_account_count}`,  // Display the completed account count and total account count
            width: 160,  // 设置宽度
        },
        {
            title: '操作',
            render: (_, record) => <Button onClick={() => fetchTransactionDetails(record.task_id)}>查看详情</Button>,  // Clicking will show details based on task_id
            width: 120,  // 设置宽度
        },
    ];

    // Table columns to display the transaction details
    const transactionColumns = [
        { title: '序号', render: (_, __, index) => index + 1 }, // 行号
        { title: '交易组ID', render: (_, record) => record.id }, // 交易组ID 使用items里的id
        { title: '买入 / 卖出', render: (_, record) => record.direction === 'BUY' ? '买入' : '卖出' }, // 买入/卖出，基于direction字段
        { title: '成交价格', dataIndex: 'executed_price' }, // 成交价格
        { title: '计划时间', dataIndex: 'expire_time', render: (text) => new Date(text * 1000).toLocaleString() }, // 转为时间戳展示
        {
            title: '交易者地址', dataIndex: 'trader_address',
            // render: (address) => formattedAddress(address)
            render: (text, record) => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <a href={record.trader_scan_url}>{formattedAddress(text)}</a>
                    <Button
                        size="small"
                        onClick={() => copyToClipboard(text)}>
                        复制
                    </Button>
                </div>
            )
        },
        { title: '最低接收数量', dataIndex: 'amount_out_min' },
        { title: '数量', dataIndex: 'amount' },
        { title: '状态', dataIndex: 'status' },
        {
            title: '交易哈希', dataIndex: 'tx_hash', render: (text, record) => {
                // 如果 scan_url 为空
                if (!record.scan_url) {
                    return <a href={`https://basescan.org/address/${text}`} target="_blank" rel="noopener noreferrer">
                        {formattedAddress(text)}
                    </a>;
                }

                // 如果 scan_url 存在，则显示超链接
                return (
                    <a href={record.scan_url} target="_blank" rel="noopener noreferrer">
                        {formattedAddress(text)}
                    </a>
                );
            },
        },
        // { title: '操作', dataIndex: 'scan_url', render: (url) => <a href={url} target="_blank" rel="noopener noreferrer">scanurl</a> }
    ];

    const handleProjectChange = (value) => {
        setSelectedAccountProject(value);
        console.log('selected pro', value);
        const selectedProject = projectList.find(p => p.project_name === value);
        setSelectedProjectDetails(selectedProject || null);
    };

    const handleEstimate = async () => {
        if (!selectedProjectDetails || !selectedProjectDetails.token_address) {
            message.warning('请选择项目，获取 token 地址后再试');
            return;
        }

        const tokenAddress = selectedProjectDetails.token_address;

        if (price && !amount) {
            const estAmount = await estimateAmountByPrice(tokenAddress, price);
            setAmount(estAmount);
        } else if (amount && !price) {
            const estPrice = await estimatePriceByAmount(tokenAddress, amount);
            setPrice(estPrice);
        } else {
            message.info('请仅填写价格或金额其中之一');
        }
    };

    const handleStopTask = async (task_id) => {
        const token = localStorage.getItem('token');
        const urlMap = {
            prepare: '/api/v1/batch_token_trading/stop',
            neutral: '/api/v1/neutral_token_trading/stop',
            limit: '/api/v1/limit_order_trading/cancel',
            disperse: '/api/v1/disperse_trading/stop'
        };

        try {
            const res = await axios.post(urlMap[taskType], { task_id }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (res.data.code === 0) {
                message.success('任务已停止');
                fetchTasks();
            } else {
                message.error(res.data.msg || '停止任务失败');
            }
        } catch (err) {
            console.error(err);
            message.error('停止任务请求失败');
        }
    };

    const prepareColumns = [
        { title: '序号', render: (_, __, i) => i + 1, width: 60 },
        { title: 'ID', dataIndex: 'task_id', width: 80 },
        {
            title: '开始',
            dataIndex: 'start_time',
            render: ts => dayjs.unix(ts).format('YYYY-MM-DD HH:mm:ss'),
            width: 160,
        },
        {
            title: '预估结束',
            dataIndex: 'estimated_end_time',
            render: ts => dayjs.unix(ts).format('YYYY-MM-DD HH:mm:ss'),
            width: 160,
        },
        { title: '总交易', dataIndex: 'total_txs', width: 80 },
        { title: '完成交易', dataIndex: 'completed_txs', width: 100 },
        { title: '失败交易', dataIndex: 'failed_txs', width: 100 },
        { title: 'fund比例', dataIndex: 'fund_percentage', width: 80 },
        {
            title: 'pair地址',
            dataIndex: 'pair_token_address',
            width: 320,
            render: (text, record) => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <a href={getScanUrl(record.chain_id, 'address', text)} target="_blank" rel="noopener noreferrer">
                        {formattedAddress(text)}
                    </a>
                    <Button size="small" onClick={() => copyToClipboard(text)}>复制</Button>
                </div>
            )
        },
        {
            title: 'token地址',
            dataIndex: 'token_addresses',
            width: 400,
            render: (text, record) => {
                const addresses = text.split(',').filter(Boolean);
                return (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
                        {addresses.map(addr => (
                            <div key={addr} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <a href={getScanUrl(record.chain_id, 'address', addr)} target="_blank" rel="noopener noreferrer">
                                    {formattedAddress(addr)}
                                </a>
                                <Button size="small" onClick={() => copyToClipboard(addr)}>复制</Button>
                            </div>
                        ))}
                    </div>
                );
            }
        },
        { title: '钱包总数', dataIndex: 'total_wallets', width: 80 },
        { title: '完成钱包数', dataIndex: 'completed_wallets', width: 100 },
        { title: '轮数', dataIndex: 'trading_rounds', width: 60 },
        { title: '等待(s)', dataIndex: 'wait_seconds', width: 80 },
        { title: '钱包组', dataIndex: 'group_name', width: 120 },
        { title: '状态', dataIndex: 'status', width: 100 },
        {
            title: '操作',
            width: 100,
            render: (_, record) => (
                <div style={{ display: 'flex', gap: '8px' }}>
                    <Button size="small" onClick={() => handleViewDetail(record.task_id)}>查看详情</Button>
                    <Popconfirm
                        title="确定要停止该任务吗？"
                        onConfirm={() => handleStopTask(record.task_id)}
                        okText="确认"
                        cancelText="取消"
                    >
                        <Button size="small" danger>停止</Button>
                    </Popconfirm>
                </div>
            )
        }
    ]

    const neutralColumns = [
        { title: '序号', render: (_, __, i) => i + 1 },
        { title: '任务ID', dataIndex: 'task_id' },
        { title: '开始', dataIndex: 'start_time', render: ts => dayjs.unix(ts).format('YYYY-MM-DD HH:mm:ss') },
        { title: '预估结束', dataIndex: 'estimated_end_time', render: ts => dayjs.unix(ts).format('YYYY-MM-DD HH:mm:ss') },
        { title: '持续(s)', dataIndex: 'duration_seconds' },
        { title: '完成quote', dataIndex: 'completed_quote' },
        { title: '总quote', dataIndex: 'total_quote' },
        { title: '完成swaps', dataIndex: 'completed_swaps' },
        { title: '总swaps', dataIndex: 'total_swaps' },
        { title: '失败swaps', dataIndex: 'failed_swaps' },
        { title: '每次swap最大报价', dataIndex: 'max_quote_per_swap' },
        {
            title: 'pair地址',
            dataIndex: 'pair_address',
            width: 320,
            render: (text, record) => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <a href={getScanUrl(record.chain_id, 'address', text)} target="_blank" rel="noopener noreferrer">
                        {formattedAddress(text)}
                    </a>
                    <Button size="small" onClick={() => copyToClipboard(text)}>复制</Button>
                </div>
            )
        },
        {
            title: 'quote地址',
            dataIndex: 'quote_address',
            width: 320,
            render: (text, record) => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <a href={getScanUrl(record.chain_id, 'address', text)} target="_blank" rel="noopener noreferrer">
                        {formattedAddress(text)}
                    </a>
                    <Button size="small" onClick={() => copyToClipboard(text)}>复制</Button>
                </div>
            )
        },
        { title: '钱包组', dataIndex: 'group_names'},
        { title: '状态', dataIndex: 'status' },
        {
            title: '操作',
            render: (_, record) => (
                <div style={{ display: 'flex', gap: '8px' }}>
                    <Button size="small" onClick={() => handleViewDetail(record.task_id)}>查看详情</Button>
                    <Popconfirm
                        title="确定要停止该任务吗？"
                        onConfirm={() => handleStopTask(record.task_id)}
                        okText="确认"
                        cancelText="取消"
                    >
                        <Button size="small" danger>停止</Button>
                    </Popconfirm>
                </div>
            )
        }
    ]

    const limitOrderColumns = [
        { title: '序号', render: (_, __, i) => i + 1, width: 60 },
        {
            title: '任务ID',
            dataIndex: 'task_id',
            width: 80,
            render: (taskId, record) => taskId ?? record.id ?? '-'
        },
        { title: '钱包组名', dataIndex: 'group_name', width: 140 },
        { title: '链', dataIndex: 'chain_id', width: 60 },
        {
            title: '开始时间',
            dataIndex: 'created_at',
            width: 160,
            render: ts => dayjs.unix(ts).format('YYYY-MM-DD HH:mm:ss')
        },
        { title: '执行时长', dataIndex: 'executed_time', width: 140 },
        { title: '代币地址', dataIndex: 'token_address', width: 280,
            render: (text, record) => {
                const addresses = text.split(',').filter(Boolean);
                return (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
                        {addresses.map(addr => (
                            <div key={addr} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <a href={getScanUrl(record.chain_id, 'address', addr)} target="_blank" rel="noopener noreferrer">
                                    {formattedAddress(addr)}
                                </a>
                                <Button size="small" onClick={() => copyToClipboard(addr)}>复制</Button>
                            </div>
                        ))}
                    </div>
                );
            }
        },
        { title: '配对代币', dataIndex: 'pair_token_address', width: 280,
            render: (text, record) => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <a href={getScanUrl(record.chain_id, 'address', text)} target="_blank" rel="noopener noreferrer">
                        {formattedAddress(text)}
                    </a>
                    <Button size="small" onClick={() => copyToClipboard(text)}>复制</Button>
                </div>
            )
        },
        { title: '最小价格', dataIndex: 'min_price', width: 100 },
        { title: '最大价格', dataIndex: 'max_price', width: 100 },
        { title: '最小买入', dataIndex: 'buy_amount_min', width: 100 },
        { title: '最大买入', dataIndex: 'buy_amount_max', width: 100 },
        { title: '最小卖出', dataIndex: 'sell_amount_min', width: 100 },
        { title: '最大卖出', dataIndex: 'sell_amount_max', width: 100 },
        { title: '滑点', dataIndex: 'slippage', width: 80 },
        { title: '状态', dataIndex: 'status', width: 100 },
        { title: '已买入', dataIndex: 'executed_buy_amount', width: 100 },
        { title: '已卖出', dataIndex: 'executed_sell_amount', width: 100 },
        {
            title: '操作',
            width: 180,
            render: (_, record) => (
                <div style={{ display: 'flex', gap: '8px' }}>
                    <Button size="small" onClick={() => handleViewDetail(record)}>查看详情</Button>
                    <Popconfirm
                        title="确定取消该任务？"
                        onConfirm={() => handleStopTask(record.task_id)}
                        okText="确认"
                        cancelText="取消"
                    >
                        <Button size="small" danger>取消交易</Button>
                    </Popconfirm>
                </div>
            )
        }
    ]

    const disperseColumns = [
        { title: '序号', render: (_, __, i) => i + 1, width: 60 },
        { title: '任务ID', dataIndex: 'task_id', width: 80 },
        {
            title: '开始时间',
            dataIndex: 'start_time',
            width: 160,
            render: ts => ts ? dayjs.unix(ts).format('YYYY-MM-DD HH:mm:ss') : '-',
        },
        { title: '持续时间(s)', dataIndex: 'duration_seconds', width: 100 },
        { title: '买入金额总计', dataIndex: 'total_buy_amount', width: 160 },
        { title: '卖出金额总计', dataIndex: 'total_sell_amount', width: 160 },
        { title: '完成钱包数', dataIndex: 'completed_wallets', width: 140 },
        { title: '失败钱包数', dataIndex: 'failed_wallets', width: 140 },
        { title: '总钱包数', dataIndex: 'total_wallets', width: 120 },
        {
            title: 'token地址',
            dataIndex: 'token_address',
            width: 260,
            render: (text, record) => {
                const addresses = text.split(',').filter(Boolean);
                return (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
                        {addresses.map(addr => (
                            <div key={addr} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <a href={getScanUrl(record.chain_id, 'address', addr)} target="_blank" rel="noopener noreferrer">
                                    {formattedAddress(addr)}
                                </a>
                                <Button size="small" onClick={() => copyToClipboard(addr)}>复制</Button>
                            </div>
                        ))}
                    </div>
                );
            }
        },
        {
            title: 'pair token地址',
            dataIndex: 'pair_address',
            width: 260,
            render: (text, record) => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <a href={getScanUrl(record.chain_id, 'address', text)} target="_blank" rel="noopener noreferrer">
                        {formattedAddress(text)}
                    </a>
                    <Button size="small" onClick={() => copyToClipboard(text)}>复制</Button>
                </div>
            )
        },
        { title: '状态', dataIndex: 'status', width: 100 },
        {
            title: '操作',
            width: 160,
            render: (_, record) => (
                <div style={{ display: 'flex', gap: '8px' }}>
                    <Button size="small" onClick={() => handleViewDetail(record.task_id)}>查看详情</Button>
                    <Button size="small" type="primary" onClick={() => openDisperseModal(record.task_id)}>查询交易事务</Button>
                    <Popconfirm
                        title="确定终止该任务？"
                        onConfirm={() => handleStopTask(record.task_id)}
                        okText="确定"
                        cancelText="取消"
                    >
                        <Button size="small" danger>终止</Button>
                    </Popconfirm>
                </div>
            )
        }
    ];

    // 打散交易事务列表（弹窗）列：不包含“操作”列
    const disperseTransactionColumns = [
        { title: '序号', width: 60, render: (_, __, i) => (dispersePage - 1) * dispersePageSize + i + 1 },
        { title: '事务ID', dataIndex: 'id', width: 80 },
        {
            title: '源钱包',
            dataIndex: 'source_wallet_address',
            width: 260,
            render: (text) => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span>{formattedAddress(text)}</span>
                    <Button size="small" onClick={() => copyToClipboard(text)}>复制</Button>
                </div>
            )
        },
        {
            title: '目标钱包',
            dataIndex: 'target_wallet_address',
            width: 260,
            render: (text) => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span>{formattedAddress(text)}</span>
                    <Button size="small" onClick={() => copyToClipboard(text)}>复制</Button>
                </div>
            )
        },
        { title: '状态', dataIndex: 'status', width: 120 },
        { title: '转移序号', dataIndex: 'transfer_sequence', width: 100 },
        { title: '卖出量', dataIndex: 'sell_amount', width: 180 },
        { title: '买入量', dataIndex: 'buy_amount', width: 180 },
        { title: '成交价', dataIndex: 'executed_price', width: 120 },
        { title: '错误信息', dataIndex: 'error_msg', width: 200, render: (t) => t || '-' },
        {
            title: '创建时间',
            dataIndex: 'created_at',
            width: 160,
            render: (ts) => ts ? dayjs.unix(ts).format('YYYY-MM-DD HH:mm:ss') : '-',
        },
        {
            title: '更新时间',
            dataIndex: 'updated_at',
            width: 160,
            render: (ts) => ts ? dayjs.unix(ts).format('YYYY-MM-DD HH:mm:ss') : '-',
        },
        {
            title: 'sell tx',
            dataIndex: 'sell_tx_hash',
            width: 280,
            render: (text) => text ? (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span>{formattedAddress(text)}</span>
                    <Button size="small" onClick={() => copyToClipboard(text)}>复制</Button>
                </div>
            ) : '-'
        },
        {
            title: 'buy tx',
            dataIndex: 'buy_tx_hash',
            width: 280,
            render: (text) => text ? (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span>{formattedAddress(text)}</span>
                    <Button size="small" onClick={() => copyToClipboard(text)}>复制</Button>
                </div>
            ) : '-'
        },
    ];



    const prepareDetail = [
        { title: '序号', render: (_, __, i) => i + 1, width: 60 },
        { title: '轮次', dataIndex: 'round', width: 60 },
        { title: '总轮数', dataIndex: 'total_rounds', width: 80 },
        { title: '方向', dataIndex: 'direction', width: 80 },
        {
            title: '买入时间',
            dataIndex: 'buy_time',
            render: ts => ts ? dayjs.unix(ts).format('YYYY-MM-DD HH:mm:ss') : '-',
            width: 160
        },
        {
            title: '卖出时间',
            dataIndex: 'sell_time',
            render: ts => ts ? dayjs.unix(ts).format('YYYY-MM-DD HH:mm:ss') : '-',
            width: 160
        },
        {
            title: '交易地址',
            dataIndex: 'trader_address',
            width: 260,
            render: text => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <a href={getScanUrl(taskDetail.chain_id, 'address', text)} target="_blank" rel="noopener noreferrer">
                        {formattedAddress(text)}
                    </a>
                    <Button size="small" onClick={() => copyToClipboard(text)}>复制</Button>
                </div>
            )
        },
        {
            title: 'token地址',
            dataIndex: 'token_address',
            width: 260,
            render: text => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <a href={getScanUrl(taskDetail.chain_id, 'address', text)} target="_blank" rel="noopener noreferrer">
                        {formattedAddress(text)}
                    </a>
                    <Button size="small" onClick={() => copyToClipboard(text)}>复制</Button>
                </div>
            )
        },
        { title: '价格', dataIndex: 'executed_price', width: 120 },
        { title: '数量', dataIndex: 'amount_in', width: 160 },
        { title: '状态', dataIndex: 'status', width: 100 },
        {
            title: '交易哈希',
            dataIndex: 'tx_hash',
            width: 280,
            render: text => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <a href={getScanUrl(taskDetail.chain_id, 'tx', text)} target="_blank" rel="noopener noreferrer">
                        {formattedAddress(text)}
                    </a>
                    <Button size="small" onClick={() => copyToClipboard(text)}>复制</Button>
                </div>
            )
        },
        {
            title: '错误信息',
            dataIndex: 'msg',
            width: 200,
            render: text => text || '-'
        }
    ]

    const neutralDetail = [
        { title: '序号', render: (_, __, i) => i + 1, width: 60 },
        {
            title: '创建时间',
            dataIndex: 'created_at',
            width: 160,
            render: ts => ts ? dayjs.unix(ts).format('YYYY-MM-DD HH:mm:ss') : '-',
        },
        {
            title: '买地址',
            dataIndex: 'buyer_address',
            width: 260,
            render: text => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <a href={getScanUrl(taskDetail.chain_id, 'address', text)} target="_blank" rel="noopener noreferrer">
                        {formattedAddress(text)}
                    </a>
                    <Button size="small" onClick={() => copyToClipboard(text)}>复制</Button>
                </div>
            )
        },
        {
            title: '卖地址',
            dataIndex: 'seller_address',
            width: 260,
            render: text => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <a href={getScanUrl(taskDetail.chain_id, 'address', text)} target="_blank" rel="noopener noreferrer">
                        {formattedAddress(text)}
                    </a>
                    <Button size="small" onClick={() => copyToClipboard(text)}>复制</Button>
                </div>
            )
        },
        {
            title: 'swap时间',
            dataIndex: 'swap_time',
            width: 160,
            render: ts => ts ? dayjs.unix(ts).format('YYYY-MM-DD HH:mm:ss') : '-',
        },
        { title: 'quote金额', dataIndex: 'quote_amount', width: 160 },
        { title: 'token数量', dataIndex: 'token_amount', width: 160 },
        {
            title: 'token地址',
            dataIndex: 'token_address',
            width: 260,
            render: text => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <a href={getScanUrl(taskDetail.chain_id, 'address', text)} target="_blank" rel="noopener noreferrer">
                        {formattedAddress(text)}
                    </a>
                    <Button size="small" onClick={() => copyToClipboard(text)}>复制</Button>
                </div>
            )
        },
        {
            title: 'quote地址',
            dataIndex: 'quote_address',
            width: 260,
            render: text => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <a href={getScanUrl(taskDetail.chain_id, 'address', text)} target="_blank" rel="noopener noreferrer">
                        {formattedAddress(text)}
                    </a>
                    <Button size="small" onClick={() => copyToClipboard(text)}>复制</Button>
                </div>
            )
        },
        { title: '状态', dataIndex: 'status', width: 100 },
        { title: 'swap_mode', dataIndex: 'swap_mode', width: 120 },
        { title: 'limit_price', dataIndex: 'limit_price', width: 120 },
        { title: 'current_price', dataIndex: 'current_price', width: 120 },
        {
            title: 'buy tx',
            dataIndex: 'buy_tx_hash',
            width: 280,
            render: text => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <a href={getScanUrl(taskDetail.chain_id, 'tx', text)} target="_blank" rel="noopener noreferrer">
                        {formattedAddress(text)}
                    </a>
                    <Button size="small" onClick={() => copyToClipboard(text)}>复制</Button>
                </div>
            )
        },
        {
            title: 'sell tx',
            dataIndex: 'sell_tx_hash',
            width: 280,
            render: text => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <a href={getScanUrl(taskDetail.chain_id, 'tx', text)} target="_blank" rel="noopener noreferrer">
                        {formattedAddress(text)}
                    </a>
                    <Button size="small" onClick={() => copyToClipboard(text)}>复制</Button>
                </div>
            )
        }
    ]

    const limitTaskDetail = [
        { title: '交易方向', dataIndex: 'direction', width: 80 },
        { title: '触发价格', dataIndex: 'trigger_price', width: 100 },
        { title: '交易数量', dataIndex: 'amount_in', width: 120 },
        { title: '执行价格', dataIndex: 'executed_price', width: 100 },
        { title: '状态', dataIndex: 'status', width: 80 },
        { title: '交易哈希', dataIndex: 'tx_hash', width: 300, render: text => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <a href={getScanUrl(taskDetail.chain_id, 'tx', text)} target="_blank" rel="noopener noreferrer">
                        {formattedAddress(text)}
                    </a>
                    <Button size="small" onClick={() => copyToClipboard(text)}>复制</Button>
                </div>
            )},
        { title: '时间', dataIndex: 'execute_time', width: 160, render: ts => dayjs.unix(ts).format('YYYY-MM-DD HH:mm:ss') }
    ]

    const disperseDetail = [
        { title: '序号', render: (_, __, i) => i + 1, width: 60 },
        {
            title: '创建时间',
            dataIndex: 'created_at',
            width: 160,
            render: ts => ts ? dayjs.unix(ts).format('YYYY-MM-DD HH:mm:ss') : '-',
        },
        {
            title: '买地址',
            dataIndex: 'buyer_address',
            width: 260,
            render: text => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <a href={getScanUrl(taskDetail.chain_id, 'address', text)} target="_blank" rel="noopener noreferrer">
                        {formattedAddress(text)}
                    </a>
                    <Button size="small" onClick={() => copyToClipboard(text)}>复制</Button>
                </div>
            )
        },
        {
            title: '卖地址',
            dataIndex: 'seller_address',
            width: 260,
            render: text => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <a href={getScanUrl(taskDetail.chain_id, 'address', text)} target="_blank" rel="noopener noreferrer">
                        {formattedAddress(text)}
                    </a>
                    <Button size="small" onClick={() => copyToClipboard(text)}>复制</Button>
                </div>
            )
        },
        {
            title: 'swap时间',
            dataIndex: 'swap_time',
            width: 160,
            render: ts => ts ? dayjs.unix(ts).format('YYYY-MM-DD HH:mm:ss') : '-',
        },
        { title: 'quote金额', dataIndex: 'quote_amount', width: 160 },
        { title: 'token数量', dataIndex: 'token_amount', width: 160 },
        {
            title: 'token地址',
            dataIndex: 'token_address',
            width: 260,
            render: text => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <a href={getScanUrl(taskDetail.chain_id, 'address', text)} target="_blank" rel="noopener noreferrer">
                        {formattedAddress(text)}
                    </a>
                    <Button size="small" onClick={() => copyToClipboard(text)}>复制</Button>
                </div>
            )
        },
        {
            title: 'quote地址',
            dataIndex: 'quote_address',
            width: 260,
            render: text => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <a href={getScanUrl(taskDetail.chain_id, 'address', text)} target="_blank" rel="noopener noreferrer">
                        {formattedAddress(text)}
                    </a>
                    <Button size="small" onClick={() => copyToClipboard(text)}>复制</Button>
                </div>
            )
        },
        { title: '状态', dataIndex: 'status', width: 100 },
        {
            title: 'buy tx',
            dataIndex: 'buy_tx_hash',
            width: 280,
            render: text => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <a href={getScanUrl(taskDetail.chain_id, 'tx', text)} target="_blank" rel="noopener noreferrer">
                        {formattedAddress(text)}
                    </a>
                    <Button size="small" onClick={() => copyToClipboard(text)}>复制</Button>
                </div>
            )
        },
        {
            title: 'sell tx',
            dataIndex: 'sell_tx_hash',
            width: 280,
            render: text => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <a href={getScanUrl(taskDetail.chain_id, 'tx', text)} target="_blank" rel="noopener noreferrer">
                        {formattedAddress(text)}
                    </a>
                    <Button size="small" onClick={() => copyToClipboard(text)}>复制</Button>
                </div>
            )
        }
    ]

    return (
        <Content style={{ padding: '20px' }}>
            {/* 查询项目组账户信息 - 第一行 */}
            <Row gutter={24} align="middle" style={{ marginBottom: 16 }}>
                {/* 项目选择 */}
                <Col span={6}>
                    <Form.Item
                        label="项目名"
                        name="project_name"
                        rules={[{ required: true, message: '请选择项目名' }]}
                        style={{ marginBottom: 0 }}
                    >
                        <Select
                            allowClear
                            placeholder="请选择项目"
                            value={selectedAccountProject}
                            onChange={handleProjectChange}
                            loading={loading}
                            style={{ width: '100%' }}
                        >
                            {projectList.map(project => (
                                <Option key={project.id} value={project.project_name}>
                                    {project.project_name}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>

                {/* 操作按钮 */}
                <Col span={8}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Button type="primary" onClick={fetchProjectAccounts} loading={loading}>
                            更新余额
                        </Button>
                        <Button type="primary" onClick={() => setAddWalletModalVisible(true)}>
                            添加钱包组
                        </Button>
                        <Button danger onClick={openDeleteModal}>
                            删除钱包组
                        </Button>
                    </div>
                </Col>

                {/* 估算相关输入 */}
                <Col span={10}>
                    <div style={{display: 'flex', justifyContent: 'space-between'}}>
                        <InputNumber
                            placeholder="目标价格"
                            value={price}
                            onChange={setPrice}
                            style={{width: '30%'}}
                            min={0}
                        />
                        <InputNumber
                            placeholder="买入金额"
                            value={amount}
                            onChange={setAmount}
                            style={{width: '30%'}}
                        />
                        <div style={{fontSize: 10, color: '#888', marginTop: 4}}>
                            {amount > 0
                                ? '买入WBNB数量'
                                : amount < 0
                                    ? '卖出token数量'
                                    : '正数为买入WBNB，负数为卖出token'}
                        </div>
                        <Button type="default" onClick={handleEstimate} style={{width: '30%'}}>
                            计算
                        </Button>
                    </div>
                </Col>
            </Row>

            {/* 第二行：项目Token地址和相关链接 */}
            {selectedProjectDetails && selectedProjectDetails.token_address && (
                <Row gutter={24} align="middle" style={{marginBottom: 12}}>
                    {/* Token 地址和复制按钮 */}
                    <Col span={10}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <span>        项目Token地址:</span>
                            {formattedAddress(selectedProjectDetails.token_address)}
                            <Button size="small" onClick={() => copyToClipboard(selectedProjectDetails.token_address)}>
                                复制
                            </Button>
                        </div>
                    </Col>

                    {/* 链接合集（占据整行右侧） */}
                    <Col span={14}>
                        <div style={{ display: 'flex', gap: '16px', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                            {selectedProjectDetails.scan_url && (
                                <a href={selectedProjectDetails.scan_url} target="_blank" rel="noopener noreferrer">
                                    Scan URL
                                </a>
                            )}
                            {selectedProjectDetails.dextool_url && (
                                <a href={selectedProjectDetails.dextool_url} target="_blank" rel="noopener noreferrer">
                                    Dextool URL
                                </a>
                            )}
                            {selectedProjectDetails.dexscreener_url && (
                                <a href={selectedProjectDetails.dexscreener_url} target="_blank" rel="noopener noreferrer">
                                    Dexscreener URL
                                </a>
                            )}
                            {selectedProjectDetails.gmgn_url && (
                                <a href={selectedProjectDetails.gmgn_url} target="_blank" rel="noopener noreferrer">
                                    GMGN URL
                                </a>
                            )}
                        </div>
                    </Col>
                </Row>
            )}


            {/* Add Wallet Modal */}
            <Modal
                title="选择钱包组"
                visible={addWalletModalVisible}
                onCancel={() => setAddWalletModalVisible(false)}
                footer={null}
                width={600}
            >
                <Form>
                    <Form.Item label="选择钱包组" name="wallet_group">
                        <Select
                            allowClear
                            placeholder="选择钱包组"
                            value={selectedWalletGroup}
                            onChange={setSelectedWalletGroup}
                            style={{ width: '100%' }}
                        >
                            {walletGroups
                                .filter(group => !projectData.some(project => project.group_name === group.name)) // 排除项目中已存在的钱包组
                                .map(group => (
                                    <Option key={group.group_id} value={group.group_id}>
                                        {group.name}
                                    </Option>
                                ))}
                        </Select>
                    </Form.Item>
                    <Form.Item>
                        <Button
                            type="primary"
                            onClick={handleAddWalletToProject}
                            block
                        >
                            确定添加
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>

            {/* 删除钱包组弹窗 */}
            <Modal
                title="删除钱包组"
                visible={deleteModalVisible}
                onCancel={() => setDeleteModalVisible(false)}
                onOk={handleDeleteWalletGroup}
                okText="确定删除"
                confirmLoading={loading}
                destroyOnClose
            >
                <Row gutter={16} align="middle" style={{ marginBottom: 16 }}>
                    <Col span={8}>选择钱包组：</Col>
                    <Col span={16}>
                        <Select
                            style={{ width: '100%' }}
                            placeholder="请选择钱包组"
                            onChange={(value) => setSelectedGroup(value)}
                            allowClear
                        >

                            {uniqueProjectData(projectData).map((item) => (
                                <Option key={item.group_id} value={item.group_id}>
                                    {item.group_name}
                                </Option>
                            ))}
                        </Select>
                    </Col>
                </Row>
            </Modal>

            {/* 项目组账户列表 */}
            <Table
                rowKey="address"
                columns={projectColumns}
                dataSource={projectData}
                loading={loading}
                pagination={{
                    pageSize: 10,
                    showSizeChanger: false
                }}
            />

            {/* 创建交易组 和 查询交易组列表 */}
            <Row gutter={16}>
                {/* 创建交易组 */}
                <Col span={10}>
                    <Form form={form} onFinish={createTradingGroup} layout="vertical">
                        <h2>交易组发出</h2>

                        {/* 第一行：钱包组、账户数量、总价值、价格限制 */}
                        <Row gutter={16}>
                            <Col span={6}>
                                <Form.Item
                                    label="买入 / 卖出"
                                    name="direction"
                                    rules={[{ required: true, message: '请选择买入或卖出' }]}
                                >
                                    <Select
                                        allowClear>
                                        <Option value="BUY">买入</Option>
                                        <Option value="SELL">卖出</Option>
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col span={6}>
                                <Form.Item
                                    label="钱包组"
                                    name="group_id"
                                    rules={[{ required: true, message: '请选择钱包组' }]}
                                >
                                    <Select
                                        allowClear
                                        showSearch
                                        placeholder="选择钱包组"
                                        onSearch={fetchWalletGroups}
                                        style={{ width: '100%' }}
                                    >
                                        {walletGroups.map((group) => (
                                            <Option key={group.group_id} value={group.group_id}>
                                                {group.name}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col span={6}>
                                <Form.Item
                                    label="项目名"
                                    name="project_name"
                                    rules={[{ required: true, message: '请选择项目名' }]}
                                >
                                    <Select
                                        allowClear
                                        showSearch
                                        placeholder="选择项目"
                                        value={selectedCreateTradeProject}
                                        onChange={setSelectedCreateTradeProject}
                                        loading={loading}
                                        style={{ width: '100%' }}
                                    >
                                        {projectList.map(project => (
                                            <Option key={project.id} value={project.project_name}>
                                                {project.project_name}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>

                            {/* 项目Token总数量 */}
                            <Col span={6}>
                                <Form.Item
                                    label="Token总数"
                                    name="total_amount"
                                    rules={[{ required: true, message: '请输入项目Token总数量' },
                                        { type: 'number', min: 0, message: '必须大于0' },
                                    ]}
                                >
                                    <InputNumber
                                        style={{ width: '100%' }}
                                        min={0}
                                        step={1}
                                        placeholder="项目Token总数量"
                                    />
                                </Form.Item>
                            </Col>

                        </Row>

                        {/* 第二行：执行时间、交易对、买入/卖出、总交易次数 */}
                        <Row gutter={16}>
                            <Col span={6}>
                                <Form.Item
                                    label="价格限制($)"
                                    name="price_limit"
                                    rules={[
                                        { required: true, message: '请输入价格限制' },
                                        { type: 'number', min: 0, message: '必须大于0' },
                                    ]}
                                >
                                    <InputNumber style={{ width: '100%' }} min={0} />
                                </Form.Item>
                            </Col>

                            <Col span={6}>
                                <Form.Item
                                    label="执行时间(分)"
                                    name="duration_minutes"
                                    rules={[
                                        { required: true, message: '请输入执行总时间' },
                                        { type: 'number', min: 1, message: '必须大于0' },
                                        {
                                            validator: (_, value) =>
                                                Number.isInteger(+value) && +value > 0
                                                    ? Promise.resolve()
                                                    : Promise.reject(new Error('执行时间必须为正整数')),
                                        },
                                    ]}
                                >
                                    <InputNumber style={{ width: '100%' }} min={1} />
                                </Form.Item>
                            </Col>

                            <Col span={12}>
                                <Form.Item
                                    label="对手方地址"
                                    name="pair_token_address"
                                    rules={[{ required: true, message: '请输入交易对手方地址' }]}
                                >

                                    <AutoComplete
                                        placeholder="对手方地址"
                                        onChange={(value) => form.setFieldsValue({ pair_token_address: value })}
                                        style={{ width: '100%' }}
                                        options={pairTokenOptions}
                                        filterOption={(inputValue, option) =>
                                            option.label.toLowerCase().includes(inputValue.toLowerCase())
                                        }
                                    />

                                </Form.Item>
                            </Col>

                        </Row>

                        <Row gutter={16}>
                            <Col span={16}>
                                <Form.Item
                                    label="fee(设置fee会走V3，留空走V2)"
                                    name="fee"
                                    rules={[{ required: false, message: '请选择fee' }]}
                                >
                                    <Select
                                        allowClear>
                                        <Option value="100">0.01%</Option>
                                        <Option value="500">0.05%</Option>
                                        <Option value="2500">0.25%</Option>
                                        <Option value="10000">1%</Option>
                                    </Select>
                                </Form.Item>
                            </Col>


                        </Row>

                        {/* 第三行：确认按钮 */}
                        <Form.Item>
                            <Button type="primary" htmlType="submit" loading={loading} block>
                                确认
                            </Button>
                        </Form.Item>

                    </Form>

                    <Col span={24}> {/* 改为 span=24，占满整行避免被挤 */}
                        <h2>停止交易</h2>
                        <Row gutter={16} align="middle">
                            <Col span={18}>
                                <Input
                                    placeholder="请输入交易组ID"
                                    style={{ width: '100%' }}
                                    value={selectedStopGroupId}
                                    onChange={(e) => setSelectedStopGroupId(e.target.value)}
                                    allowClear
                                />
                            </Col>
                            <Col span={6}>
                                <Button
                                    danger
                                    onClick={handleStopTradingGroup}
                                    block
                                    style={{
                                        height: '30px', // 设置按钮高度
                                        lineHeight: '40px', // 文本居中
                                        fontSize: '16px' // 可选：字体更大一点
                                    }}
                                >
                                    停止
                                </Button>
                            </Col>
                        </Row>
                    </Col>

                    <Col span={24}>
                        <h2>创建交易任务</h2>
                        <Form layout="vertical">
                            <Row gutter={24}>
                                <Col span={8}>
                                    <Form.Item label="任务类型">
                                        <Select value={taskType} onChange={(v) => {
                                            console.log('taskType changed to:', v);
                                            // setTaskType(v);
                                            handleTaskTypeChange(v);
                                        }}>
                                            <Option value="prepare">准备交易任务</Option>
                                            <Option value="neutral">中性交易任务</Option>
                                            <Option value="limit">限价交易任务</Option>
                                            <Option value="disperse">打散交易任务</Option>
                                        </Select>
                                    </Form.Item>
                                </Col>
                                {taskType === 'prepare' && (
                                    <>
                                        <Col span={8}>

                                            <Form.Item label="链" name="chain_id" rules={[{ required: true, message: '请选择链' }]} style={{ flex: 1, marginBottom: 0 }}>
                                                <Select
                                                    allowClear
                                                    placeholder="选择链"
                                                    value={prepareParams.chain_id}
                                                    onChange={v => setPrepareParams(p => ({...p, chain_id: v}))}
                                                    style={{ width: '100%' }}
                                                >
                                                    {chains.map((chain) => (
                                                        <Option key={chain.chain_id} value={chain.chain_id}>
                                                            {chain.chain_name}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>

                                        </Col>

                                        <Col span={8}>
                                            <Form.Item
                                                label="钱包组"
                                                name="group_id"
                                                rules={[{ required: true, message: '请选择钱包组' }]}
                                            >
                                                <Select
                                                    allowClear
                                                    showSearch
                                                    placeholder="选择钱包组"
                                                    onSearch={fetchWalletGroups}
                                                    style={{ width: '100%' }}

                                                    value={prepareParams.group_id}
                                                    onChange={v => setPrepareParams(p => ({...p, group_id: v}))}
                                                >
                                                    {walletGroups.map((group) => (
                                                        <Option key={group.group_id} value={group.group_id}>
                                                            {group.name}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>

                                        <Col span={8}>
                                            <Form.Item label="代币地址">
                                                <AutoComplete
                                                    placeholder="选择代币地址"
                                                    value={tokenAddress}
                                                    onChange={handleTokenAddressChange}
                                                    options={
                                                        selectedChain
                                                            ? Array.from(new Map(
                                                                (tokenOptions[selectedChain.chain_name] || []).map(token => [token.address, {
                                                                    value: token.address,
                                                                    label: `${token.name} - ${token.address}`,
                                                                }])
                                                            ).values())
                                                            : []
                                                    }
                                                    filterOption={(inputValue, option) =>
                                                        option.label.toLowerCase().includes(inputValue.toLowerCase())
                                                    }
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item label="资金使用%">
                                                <InputNumber min={0} max={100} step={0.1}
                                                             value={prepareParams.fund_percentage}
                                                             onChange={v => setPrepareParams(p => ({
                                                                 ...p,
                                                                 fund_percentage: v
                                                             }))}/>
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item label="买后等待时间(s)">
                                                <InputNumber min={0}
                                                             value={prepareParams.wait_seconds}
                                                             onChange={v => setPrepareParams(p => ({
                                                                 ...p,
                                                                 wait_seconds: v
                                                             }))}/>
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item label="交易轮数">
                                                <InputNumber min={1}
                                                             value={prepareParams.trading_rounds}
                                                             onChange={v => setPrepareParams(p => ({
                                                                 ...p,
                                                                 trading_rounds: v
                                                             }))}/>
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item label="任务持续时间(s)">
                                                <InputNumber min={1}
                                                             value={prepareParams.duration_seconds}
                                                             onChange={v => setPrepareParams(p => ({
                                                                 ...p,
                                                                 duration_seconds: v
                                                             }))}/>
                                            </Form.Item>
                                        </Col>
                                    </>
                                )}
                                {taskType === 'neutral' && (
                                    <>
                                        <Col span={8}>

                                            <Form.Item label="链" name="chain_id" rules={[{ required: true, message: '请选择链' }]} style={{ flex: 1, marginBottom: 0 }}>
                                                <Select
                                                    allowClear
                                                    placeholder="选择链"
                                                    value={neutralParams.chain_id}
                                                    onChange={v => setNeutralParams(p => ({...p, chain_id: v}))}
                                                    style={{ width: '100%' }}
                                                >
                                                    {chains.map((chain) => (
                                                        <Option key={chain.chain_id} value={chain.chain_id}>
                                                            {chain.chain_name}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>

                                        <Col span={8}>

                                            <Form.Item
                                                label="钱包组"
                                                name="group_ids"
                                                rules={[{ required: true, message: '请选择钱包组' }]}
                                            >
                                                <Select
                                                    mode="multiple" // ✅ 启用多选模式
                                                    allowClear
                                                    showSearch
                                                    placeholder="选择钱包组"
                                                    onSearch={fetchWalletGroups}
                                                    style={{ width: '100%' }}
                                                    value={neutralParams.group_ids}
                                                    onChange={v => setNeutralParams(p => ({ ...p, group_ids: v }))}
                                                >
                                                    {walletGroups.map((group) => (
                                                        <Option key={group.group_id} value={group.group_id}>
                                                            {group.name}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item label="币对地址" rules={[{ required: true, message: 'pair address' }]}>
                                                <Input
                                                    value={neutralParams.pair_address}
                                                    onChange={e => setNeutralParams(p => ({
                                                        ...p,
                                                        pair_address: e.target.value
                                                    }))}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item label="Quote 地址" rules={[{ required: true}]}>
                                                <AutoComplete
                                                    placeholder="Quote Token 地址"
                                                    value={quoteAddress}
                                                    onChange={setQuoteAddress}
                                                    options={Array.from(new Map(
                                                        Object.entries(tokenOptions).flatMap(([chain_name, tokens]) =>
                                                            tokens.map(token => [token.address, {
                                                                value: token.address,
                                                                label: `${chain_name}-${token.name} - ${token.address}`,
                                                            }])
                                                        )
                                                    ).values())}
                                                    filterOption={(inputValue, option) =>
                                                        option.label.toLowerCase().includes(inputValue.toLowerCase())
                                                    }
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item label="单次交易最大值" rules={[{ required: true }]}>
                                                <InputNumber
                                                    value={neutralParams.max_quote_per_swap}
                                                    onChange={v => setNeutralParams(p => ({
                                                        ...p,
                                                        max_quote_per_swap: v
                                                    }))}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item label="最大总报价">
                                                <InputNumber
                                                    value={neutralParams.total_quote}
                                                    onChange={v => setNeutralParams(p => ({...p, total_quote: v}))}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item label="持续时间(s)">
                                                <InputNumber
                                                    min={1}
                                                    value={neutralParams.duration_seconds}
                                                    onChange={v => setNeutralParams(p => ({...p, duration_seconds: v}))}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item label="交易模式" rules={[{ required: true, message: '请选择交易模式' }]}>
                                                <Select
                                                    placeholder="选择交易模式"
                                                    value={neutralParams.swap_mode}
                                                    onChange={v => setNeutralParams(p => ({...p, swap_mode: v}))}
                                                >
                                                    <Option value="base_neutral">base_neutral</Option>
                                                    <Option value="follow_btc">follow_btc</Option>
                                                    <Option value="limit_suppress_sell">limit_suppress_sell</Option>
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col span={8} style={{ display: 'flex', alignItems: 'flex-end' }}>
                                            <Form.Item style={{ marginBottom: 0, width: '100%' }}>
                                                <Button type="primary" onClick={handleCreateTask} style={{ width: '100%' }}>创建任务</Button>
                                            </Form.Item>
                                        </Col>
                                    </>
                                )}

                                {taskType === 'limit' && (
                                    <>
                                        <Col span={8}>
                                            <Form.Item label="链" required>
                                                <Select
                                                    placeholder="选择链"
                                                    onChange={(v) => setLimitParams(p => ({ ...p, chain_id: v }))}
                                                    value={limitParams.chain_id}
                                                >
                                                    {chains.map((chain) => (
                                                        <Option key={chain.chain_id} value={chain.chain_id}>{chain.chain_name}</Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item label="钱包组" required>
                                                <Select
                                                    placeholder="选择钱包组"
                                                    onChange={(v) => setLimitParams(p => ({ ...p, group_id: v }))}
                                                    value={limitParams.group_id}
                                                >
                                                    {walletGroups.map((group) => (
                                                        <Option key={group.group_id} value={group.group_id}>{group.name}</Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item label="代币地址" required>
                                                <Input
                                                    value={limitParams.token_address}
                                                    onChange={(e) => setLimitParams(p => ({ ...p, token_address: e.target.value }))}
                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col span={8}>
                                            <Form.Item label="流动性池地址" required>
                                                <Input
                                                    value={limitParams.pool_address}
                                                    onChange={(e) => setLimitParams(p => ({ ...p, pool_address: e.target.value }))}
                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col span={8}>
                                            <Form.Item label="配对代币地址" required>
                                                <Input
                                                    value={limitParams.pair_token_address}
                                                    onChange={(e) => setLimitParams(p => ({ ...p, pair_token_address: e.target.value }))}
                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col span={8}>
                                            <Form.Item label="最小触发价格" required>
                                                <Input
                                                    type="number"
                                                    step="any"
                                                    value={limitParams.min_price}
                                                    onChange={(e) => setLimitParams(p => ({ ...p, min_price: e.target.value }))}
                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col span={8}>
                                            <Form.Item label="最大触发价格" required>
                                                <Input
                                                    type="number"
                                                    step="any"
                                                    value={limitParams.max_price}
                                                    onChange={(e) => setLimitParams(p => ({ ...p, max_price: e.target.value }))}
                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col span={8}>
                                            <Form.Item label="最小买入金额" required>
                                                <Input
                                                    type="number"
                                                    step="any"
                                                    value={limitParams.buy_amount_min}
                                                    onChange={(e) => setLimitParams(p => ({ ...p, buy_amount_min: e.target.value }))}
                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col span={8}>
                                            <Form.Item label="最大买入金额" required>
                                                <Input
                                                    type="number"
                                                    step="any"
                                                    value={limitParams.buy_amount_max}
                                                    onChange={(e) => setLimitParams(p => ({ ...p, buy_amount_max: e.target.value }))}
                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col span={8}>
                                            <Form.Item label="最小卖出金额" required>
                                                <Input
                                                    type="number"
                                                    step="any"
                                                    value={limitParams.sell_amount_min}
                                                    onChange={(e) => setLimitParams(p => ({ ...p, sell_amount_min: e.target.value }))}
                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col span={8}>
                                            <Form.Item label="最大卖出金额" required>
                                                <Input
                                                    type="number"
                                                    step="any"
                                                    value={limitParams.sell_amount_max}
                                                    onChange={(e) => setLimitParams(p => ({ ...p, sell_amount_max: e.target.value }))}
                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col span={8}>
                                            <Form.Item label="滑点容忍度" required>
                                                <Input
                                                    type="number"
                                                    min={0}
                                                    max={100}
                                                    value={limitParams.slippage}
                                                    onChange={(e) => setLimitParams(p => ({ ...p, slippage: e.target.value }))}
                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col span={8}>
                                            <Form.Item label="过期时间" required>
                                                <DatePicker
                                                    showTime
                                                    style={{ width: '100%' }}
                                                    onChange={(dt, dtStr) => setLimitParams(p => ({ ...p, expired_time: dt.toISOString() }))}
                                                />
                                            </Form.Item>
                                        </Col>
                                    </>
                                )}

                                {taskType === 'disperse' && (
                                    <>
                                        <Col span={8}>
                                            <Form.Item label="链" required>
                                                <Select
                                                    placeholder="选择链"
                                                    onChange={(v) => setDisperseParams(p => ({ ...p, chain_id: v }))}
                                                    value={disperseParams.chain_id}
                                                >
                                                    {chains.map((chain) => (
                                                        <Option key={chain.chain_id} value={chain.chain_id}>{chain.chain_name}</Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>

                                        <Col span={8}>
                                            <Form.Item label="源钱包组" required>
                                                <Select
                                                    placeholder="源钱包组"
                                                    onChange={(v) => setDisperseParams(p => ({ ...p, source_group_id: v }))}
                                                    value={disperseParams.source_group_id}
                                                >
                                                    {walletGroups.map((group) => (
                                                        <Option key={group.group_id} value={group.group_id}>{group.name}</Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>

                                        <Col span={8}>
                                            <Form.Item label="目标钱包组" required>
                                                <Select
                                                    placeholder="目标钱包组"
                                                    onChange={(v) => setDisperseParams(p => ({ ...p, target_group_id: v }))}
                                                    value={disperseParams.target_group_id}
                                                >
                                                    {walletGroups.map((group) => (
                                                        <Option key={group.group_id} value={group.group_id}>{group.name}</Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>

                                        <Col span={8}>
                                            <Form.Item label="代币地址" required>
                                                <Input
                                                    value={disperseParams.token_address}
                                                    onChange={(e) => setDisperseParams(p => ({ ...p, token_address: e.target.value }))}
                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col span={8}>
                                            <Form.Item label="交易对地址" required>
                                                <Input
                                                    value={disperseParams.pair_address}
                                                    onChange={(e) => setDisperseParams(p => ({ ...p, pair_address: e.target.value }))}
                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col span={8}>
                                            <Form.Item label="报价代币地址" required>
                                                <Input
                                                    value={disperseParams.quote_address}
                                                    onChange={(e) => setDisperseParams(p => ({ ...p, quote_address: e.target.value }))}
                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col span={8}>
                                            <Form.Item label="目标消减筹码量" required>
                                                <Input
                                                    type="number"
                                                    step="any"
                                                    value={disperseParams.target_amount}
                                                    onChange={(e) => setDisperseParams(p => ({ ...p, target_amount: e.target.value }))}
                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col span={8}>
                                            <Form.Item label="执行时间(秒)" required>
                                                <Input
                                                    type="number"
                                                    value={disperseParams.duration_seconds}
                                                    onChange={(e) => setDisperseParams(p => ({ ...p, duration_seconds: parseInt(e.target.value)}))}
                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col span={8}>
                                            <Form.Item label="平均转移量" required>
                                                <Input
                                                    type="number"
                                                    step="any"
                                                    value={disperseParams.average_transfer_amount}
                                                    onChange={(e) => setDisperseParams(p => ({ ...p, average_transfer_amount: e.target.value }))}
                                                />
                                            </Form.Item>
                                        </Col>
                                    </>
                                )}

                                {/* 非中性交易任务创建按钮 */}
                                {taskType !== 'neutral' && (
                                    <Col span={8} style={{ display: 'flex', alignItems: 'center' }}>
                                        <Form.Item style={{ marginBottom: 0 }}>
                                            <Button type="primary" onClick={handleCreateTask}>创建任务</Button>
                                        </Form.Item>
                                    </Col>
                                )}
                            </Row>
                        </Form>
                    </Col>


                </Col>

                {/* 查询交易组列表 */}
                <Col span={14}>
                    <h2>交易组记录</h2>
                    <Form
                        layout="vertical"
                        onFinish={fetchTradingGroups} // 只在点击查询按钮时请求数据
                        style={{ width: '100%' }}
                    >
                        {/* 第一行：项目选择、交易组ID、钱包组ID */}
                        <Row gutter={16}>
                            <Col span={8}>
                                <Form.Item
                                    label="项目名"
                                    name="project_name"
                                    rules={[{ required: false, message: '请选择项目名' }]}
                                >
                                    <Select
                                        allowClear
                                        showSearch
                                        placeholder="选择项目"
                                        value={selectedTradeInfoProject}
                                        onChange={setSelectedTradeInfoProject}
                                        loading={loading}
                                        style={{ width: '100%' }}
                                    >
                                        {projectList.map((project) => (
                                            <Option key={project.id} value={project.project_name}>
                                                {project.project_name}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="交易组ID"
                                    name="trading_group_id"
                                    style={{ width: '100%' }}
                                >
                                    <Input placeholder="请输入交易组ID" style={{ width: '100%' }} />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="钱包组ID"
                                    name="group_id"
                                    rules={[{ required: false, message: '请选择钱包组ID' }]}
                                >
                                    <Select
                                        allowClear
                                        showSearch
                                        placeholder="选择钱包组"
                                        value={selectedGroup}
                                        onChange={setSelectedGroup}
                                        style={{ width: '100%' }}
                                    >
                                        {walletGroups.map((group) => (
                                            <Option key={group.group_id} value={group.group_id}>
                                                {group.name}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>

                        {/* 第二行：时间范围和查询按钮 */}
                        <Row gutter={16} align="bottom">
                            <Col span={12}>
                                <Form.Item
                                    label="时间范围"
                                    name="time_range"
                                    style={{ width: '100%' }}
                                    rules={[
                                        { required: false, message: '请选择时间范围' },
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                if (!value || value[0] <= value[1]) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject(new Error('结束时间必须晚于开始时间'));
                                            },
                                        }),
                                    ]}
                                >
                                    <RangePicker
                                        style={{ width: '100%' }}
                                        format="YYYY-MM-DD"
                                        placeholder={['起始时间', '终止时间']}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item>
                                    <Button type="primary" htmlType="submit" block>
                                        查询
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>


                    {/* 表格展示 */}
                    <Table
                        rowKey="task_id"
                        columns={tradingGroupColumns}
                        dataSource={tradingGroups} // 需要在state中存储获取的数据
                        loading={loading}
                        scroll={{ x: 'max-content' }} // 👈 关键：启用表格横向滚动
                        pagination={{
                            pageSize: 10,
                            showSizeChanger: false,
                            total: totalItems, // 总记录数
                            onChange: (page, pageSize) => {
                                // 这里可以传递分页信息
                                fetchTradingGroups({ ...searchParams, page, size: pageSize });
                            },
                        }}
                    />
                </Col>
            </Row>

            <Modal
                title="交易组详情"
                visible={transactionModalVisible}
                onCancel={() => setTransactionModalVisible(false)}
                footer={null}
                width={1600} // Optional: adjust modal width
            >
                <Table
                    rowKey="id"
                    scroll={{ x: 'max-content' }} // 👈 关键：启用表格横向滚动
                    columns={transactionColumns}
                    dataSource={transactionDetails}
                    pagination={{ pageSize: 10 }} // Adjust pagination as necessary
                    loading={loading}
                />
            </Modal>

            <Row gutter={16}>


                {/* 查询交易任务列表 */}
                <Col span={14}>

                </Col>
            </Row>

            <Card title="交易任务列表" bordered={false}>
                <Table
                    size="small"
                    rowKey="task_id"
                    loading={loadingTasks}
                    dataSource={taskList}
                    scroll={{ x: 'max-content' }} // 👈 关键：启用表格横向滚动
                    pagination={{
                        current: currentPage,
                        total: totalTasks,
                        pageSize: 10,
                        onChange: setCurrentPage,
                    }}
                    columns={
                        taskType === 'prepare'
                            ? prepareColumns
                            : taskType === 'neutral'
                                ? neutralColumns
                                : taskType === 'limit'
                                    ? limitOrderColumns
                                    : disperseColumns
                    }
                />
            </Card>

            <Modal
                title="任务详情"
                visible={taskDetailModalVisible}
                onCancel={() => setTaskDetailModalVisible(false)}
                footer={null}
                width={3000}

            >
                {taskDetail && (
                    taskDetailType === 'limit' ? (
                        <>
                            <div style={{ marginBottom: 12 }}>
                                交易记录：{limitTransactions.length} 条
                            </div>
                            <Table
                                size="small"
                                rowKey="id"
                                scroll={{ x: 'max-content' }}
                                dataSource={limitTransactions.slice((detailPage - 1) * pageSize, detailPage * pageSize)}
                                columns={limitTaskDetail}
                                locale={{ emptyText: '接口未返回交易记录' }}
                                pagination={{
                                    current: detailPage,
                                    pageSize,
                                    total: limitTransactions.length,
                                    onChange: page => setDetailPage(page),
                                }}
                            />
                        </>
                    ) : taskDetailType === 'disperse' ? (
                        <Table
                            size="small"
                            rowKey="task_id"
                            scroll={{ x: 'max-content' }}
                            pagination={false}
                            dataSource={[taskDetail || {}]}
                            columns={Object.keys(taskDetail || {}).map((key) => ({
                                title: key,
                                dataIndex: key,
                                width: 180,
                                render: (val) => {
                                    if (val === null || val === undefined || val === '') return '-';
                                    if (typeof val === 'number' && (key.includes('time') || key.endsWith('_at')) && val > 1e9) {
                                        return dayjs.unix(val).format('YYYY-MM-DD HH:mm:ss');
                                    }
                                    return String(val);
                                },
                            }))}
                        />
                    ) : (
                        <Table
                            size="small"
                            rowKey="id"
                            scroll={{ x: 'max-content' }} // 👈 关键：启用表格横向滚动
                            dataSource={(taskDetail.items || taskDetail.transactions || []).slice((detailPage - 1) * pageSize, detailPage * pageSize)}
                            columns={taskDetailType === 'prepare' ? prepareDetail : neutralDetail}
                            pagination={{
                                current: detailPage,
                                pageSize,
                                total: (taskDetail.items || taskDetail.transactions || []).length,
                                onChange: page => setDetailPage(page),
                            }}
                        />
                    )
                )}
            </Modal>


            <Modal
                title="交易事务列表"
                visible={disperseModalVisible}
                onCancel={() => {
                    setDisperseModalVisible(false);
                    setDisperseData([]);
                    setDisperseTotal(0);
                    setDispersePage(1);
                    setDisperseFilters({
                        source_wallet_address: '',
                        target_wallet_address: '',
                        status: undefined,
                        transfer_sequence: undefined,
                    });
                }}
                footer={null}
                width={2600}
                destroyOnClose
            >
                <div style={{ display: 'flex', gap: '12px', marginBottom: 12, alignItems: 'center', flexWrap: 'wrap' }}>
                    <Input
                        placeholder="源钱包地址"
                        value={disperseFilters.source_wallet_address}
                        onChange={(e) => setDisperseFilters(p => ({ ...p, source_wallet_address: e.target.value }))}
                        style={{ width: 320 }}
                        allowClear
                    />
                    <Input
                        placeholder="目标钱包地址"
                        value={disperseFilters.target_wallet_address}
                        onChange={(e) => setDisperseFilters(p => ({ ...p, target_wallet_address: e.target.value }))}
                        style={{ width: 320 }}
                        allowClear
                    />
                    <Select
                        placeholder="状态"
                        value={disperseFilters.status}
                        onChange={(v) => setDisperseFilters(p => ({ ...p, status: v }))}
                        style={{ width: 160 }}
                        allowClear
                        options={[
                            { label: '停止', value: 'STOPPED' },
                            { label: '进行中', value: 'PROCESSING' },
                            { label: '已完成', value: 'COMPLETED' },
                        ]}
                    />
                    <InputNumber
                        placeholder="转移序号"
                        value={disperseFilters.transfer_sequence}
                        onChange={(v) => setDisperseFilters(p => ({ ...p, transfer_sequence: v }))}
                        style={{ width: 140 }}
                        min={0}
                    />
                    <Button
                        type="primary"
                        onClick={() => {
                            setDispersePage(1);
                            fetchDisperseTransactions(currentTaskId, 1);
                        }}
                    >
                        查询
                    </Button>
                </div>

                <Table
                    size="small"
                    rowKey="id"
                    loading={disperseLoading}
                    dataSource={disperseData}
                    scroll={{ x: 'max-content' }}
                    columns={disperseTransactionColumns}
                    pagination={{
                        current: dispersePage,
                        pageSize: dispersePageSize,
                        total: disperseTotal,
                        onChange: (page) => {
                            setDispersePage(page);
                            fetchDisperseTransactions(currentTaskId, page);
                        },
                        showSizeChanger: false,
                    }}
                />
            </Modal>


        </Content>
    );
};

export default ProjectGroupManagement;
